import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderRoutingModule } from './order-routing.module';
import { OrderComponent } from './order.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PipesModule } from 'src/app/theme/pipes/pipes.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {PlatformModule} from '@angular/cdk/platform';
import { TrackShipmentComponent } from './track-shipment/track-shipment.component';
import { TrackComponent } from './track/track.component';
import { TimelineComponent } from './timeline/timeline.component';
import {MatStepperModule} from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { OrderStatusPipeModule } from 'src/app/theme/pipes/order-status/order-status.module';


@NgModule({
  declarations: [OrderComponent, TrackShipmentComponent, TrackComponent, TimelineComponent],
  imports: [
    CommonModule,
    OrderRoutingModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    PipesModule,
    MatSnackBarModule,
    PlatformModule,
    MatStepperModule,
    MatDialogModule,
    OrderStatusPipeModule
    
  ],  exports: [
    TrackComponent
  ]
  
})
export class OrderModule { }
